import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { AbstractWebsiteComponent } from 'components/molecules/abstract-website-component/abstract-website-component';
import type { MenuItem } from 'components/organisms/sidebar/entities/types';
import { MenuItemComponent } from 'components/organisms/sidebar/partial/menu-item/menu-item.component';

@Component({
    selector: 'website-menu-items-list',
    templateUrl: './menu-items-list.component.html',
    styleUrls: ['./menu-items-list.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MenuItemComponent],
})
export class MenuItemsListComponent extends AbstractWebsiteComponent {
    public readonly COMPONENT_NAME = 'menu-items';

    @Input() public navigationItems: MenuItem[];
    @Input() public level = 1;
}
